/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MandatePlanningSegment } from './mandatePlanningSegment';

export type MandateSegments = MandatePlanningSegment[] | null;
